import React from "react";
import GeozoneDefaultIcon from "@images/default/geozone_default.svg";
import { translate } from "@/hooks/useLanguage";
import { LanguageKey } from "@/types/generated/LanguageKey";

interface GeozoneListImageProps {
  className?: string;
  width?: string;
  height?: string;
  image?: string;
  icon?: string;
}

const GeozoneListImage: React.FC<GeozoneListImageProps> = ({
  className,
  width = "20px",
  height = "20px",
  image,
  icon,
}) => {

  const renderContent = () => {
    if (image && image !== "") {
      return (
        <img
          className={className}
          src={image}
          alt={translate(LanguageKey.image_key)}
          width={width}
          height={height}
        />
      );
    }

    if (icon) {
      return (
        <img
          className={className}
          src={icon}
          alt={translate(LanguageKey.icon_key)}
          width={width}
          height={height}
        />
      );
    }

    return (
      <img
        className={className}
        src={GeozoneDefaultIcon}
        alt={translate(LanguageKey.icon_key)}
        width={width}
        height={height}
      />
    );
  };

  return <>{renderContent()}</>;
};

export default GeozoneListImage;
